enum BankAccountType {
    Checking = 'checking',
    Savings = 'savings',
}

export default BankAccountType;
